module.exports = __webpack_public_path__ + "static/media/IUP_wyl.69ac8ef0.svg";